function init_settings(from_php){
    var main=$(".place.settings");
    var howlerSet=_mySound.takeMuteObj();
    
    /*main.find(".pageWrap").myPageSelector({
        width: 839,
        height: 524,
        page:from_php.page
    });*/
    
    var soundObj={
        sound:main.find("#sErrCheck"),
        music:main.find("#sMusicCheck"),
    };
    function setHowler(opt){
        var name;
        for(name in opt){
            soundObj[name].off("click.hlSet");
            if(opt[name]==0){
                soundObj[name].prop('checked', true)
            }
            else{
                soundObj[name].prop('checked', false)
            }
            soundObj[name].on("click.hlSet",function(){
                var th=$(this),val=1;
                if(th.is(":checked")){
                    val=0;
                }
                _mySound.howlerSetVal(th.attr("data-mode"),val);
            });
        }
    }
    setHowler(howlerSet);
    _moduleEvents.on("howlerMute",function(hObj){
       howlerSet=hObj; 
       setHowler(howlerSet);
    });
    if(from_php.user_mail){
        $("#mainEmailConf").remove();
    }
    var soundVal=_mySound.takeVolumeObj();
    main.find("#soundSlider").on("change",function(e,val){
        _mySound.setSoundVolumeVal(val);
    }).mySlider({min:0,max:100,cur:soundVal.sound});
    main.find("#musicSlider").on("change",function(e,val){
        _mySound.setMusicVolumeVal(val);
    }).mySlider({min:0,max:100,cur:soundVal.music});
    
    
    
    
    main.find(".rowMain.premium .myFormInput").off("myFormText.ff").on("myFormText.ff",function(){

    }).myFormText({on_update:function(val){
            main.find("#confPremiumDis").html(val);
    },min:1,val:intval(from_php.premium_conf),max:1000});
    
    
    
    
//    $("#rrTT").click(function(){
//       _mySound.playSound("girl_play"); 
//    });
}